import { Controller } from "@hotwired/stimulus"
import { animate } from "animejs"

// Пример использования:
// data-controller="anime"
// data-anime-preset-value="fade-in"   -- пресет анимации
// data-anime-delay-value="0"          -- задержка в мс
// data-anime-duration-value="600"     -- длительность в мс
// data-anime-trigger-value="load"     -- когда запускать: load | hover | click | scroll

export default class extends Controller {
  static values = {
    preset:   { type: String,  default: "fade-in" },
    delay:    { type: Number,  default: 0 },
    duration: { type: Number,  default: 600 },
    trigger:  { type: String,  default: "load" }
  }

  connect() {
    if (this.triggerValue === "load") {
      this.play()
    } else if (this.triggerValue === "hover") {
      this.element.addEventListener("mouseenter", () => this.play())
    } else if (this.triggerValue === "click") {
      this.element.addEventListener("click", () => this.play())
    } else if (this.triggerValue === "scroll") {
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => { if (entry.isIntersecting) { this.play(); this._observer.disconnect() } })
      }, { threshold: 0.1 })
      this._observer.observe(this.element)
    }
  }

  disconnect() {
    this._observer?.disconnect()
  }

  play() {
    animate(this.element, { ...this._preset(), delay: this.delayValue, duration: this.durationValue })
  }

  _preset() {
    const presets = {
      "fade-in":    { opacity: [0, 1], easing: "easeOutQuad" },
      "fade-up":    { opacity: [0, 1], translateY: [30, 0], easing: "easeOutQuad" },
      "fade-down":  { opacity: [0, 1], translateY: [-30, 0], easing: "easeOutQuad" },
      "fade-left":  { opacity: [0, 1], translateX: [30, 0], easing: "easeOutQuad" },
      "fade-right": { opacity: [0, 1], translateX: [-30, 0], easing: "easeOutQuad" },
      "zoom-in":    { opacity: [0, 1], scale: [0.85, 1], easing: "easeOutBack" },
      "bounce":     { translateY: [0, -20, 0], easing: "easeInOutSine", loop: 3 },
      "pulse":      { scale: [1, 1.05, 1], easing: "easeInOutSine", loop: 2 },
    }
    return presets[this.presetValue] ?? presets["fade-in"]
  }
}
